import axios, { AxiosResponse } from 'axios';
import { LoginResponse } from 'models';

const getLocalRefreshToken = () => {
  const token = window.localStorage.getItem('refresh_token');
  return token;
};

const updateLocalAccessToken = (res: LoginResponse) => {
  localStorage.setItem('access_token', res.token);
  localStorage.setItem('refresh_token', res.refresh_token);
};

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (config: any) {
    console.log('Log: ~ file: axiosClient.ts ~ line 24 ~ config', config);
    // Do something before request is sent
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  async function (error) {
    const originalConfig = error.config;
    if (error.response.status === 401) {
      try {
        const result = await getLocalRefreshToken();
        const url = `${process.env.REACT_APP_API_URL}/api/v1/auth/token`;
        const rs: LoginResponse = await axios.post(url, {
          refresh_token: result,
        });
        updateLocalAccessToken(rs);
        return axiosClient(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }

    return Promise.reject(error);
  }
);
export default axiosClient;
